import { RouteNames } from '@/router/routeNames';
import useLocationsStore from '@/stores/useLocationsStore';
import { storeToRefs } from 'pinia';
import type { NavigationGuard, NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

const checkOrderId = (to: RouteLocationNormalized) => {
    if (!to?.params?.orderId) {
        return to.name === RouteNames.ToProcess ? true : { name: RouteNames.ToProcess };
    }

    const param = Array.isArray(to?.params?.orderId)
        ? to?.params?.orderId?.at(0)
        : to?.params?.orderId;
    const orderId = Number.parseInt(param || '0', 10);

    return {
        name: Number.isNaN(orderId) || orderId <= 0 ? RouteNames.Index : RouteNames.ToProcess,
    };
};

const invalidLocation = (): boolean => {
    const { selected } = storeToRefs(useLocationsStore());
    return !selected.value?.length;
};

const orderGuard =
    (): NavigationGuard =>
    async (to: RouteLocationNormalized): Promise<NavigationGuardReturn> => {
        if (invalidLocation()) {
            return { name: RouteNames.Index };
        } else {
            return checkOrderId(to);
        }
    };

export default orderGuard;
